import { useContext } from "react";
import { ViewerItemsColorContext } from "./viewer-items-color-context-props";

const useViewerItemsColorContext = () => {
    const context = useContext(ViewerItemsColorContext);
    if (!context) {
        throw new Error('useViewerItemsColorContext must be used within a ViewerItemsColorContextProvider');
    }
    return context;
};

export default useViewerItemsColorContext;